import { Box } from '@mui/material';
import Table from '../../../core-components/theme/components/Table/Table';
import NoDataView from '../../../globalComponents/NoDataView/NoDataView';
import { columns } from '../helper/tableHelper';
import { useLogbookTemplateTable } from '../hooks/useLogbookTemplateTable';

export default function LogbookTemplateTable({ searchString, isPending }: any) {
    const { logbookTemplates, lastElementRef, tableContainerRef, queryKey } = useLogbookTemplateTable(searchString);
    const tableColumns = columns(queryKey) as any;
    const hasNoData = !isPending && (!logbookTemplates || logbookTemplates.length === 0);

    return (
        <Box ref={tableContainerRef} sx={{ display: 'flex', flexDirection: 'column', height: '100%', opacity: isPending ? '0.3' : '1' }}>
            {hasNoData ? (
                <NoDataView message="No data available" />
            ) : (
                <Table
                    stickyHeader
                    rows={logbookTemplates}
                    columns={tableColumns}
                    lastRowRef={lastElementRef as any}
                />
            )}
        </Box>
    );
}